<script lang="ts">
    import src from './svg/upload_blue.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    export let scale: number = 1;
    let title: string = '';
</script>

<TemplateIcon {src} {scale} alt={title} hover={title} />
